import { defineStore } from "pinia";
const useSearch = defineStore("search", {
  state: () => ({
    keyWord:"",
  }),

  getters: {},

  actions: {},
});

//暴露这个useCounter模块
export default useSearch;
